import { appUrls } from 'constants/urls';
import axiosInstance from 'utils/axiosInstance';

const fetchPatientInfo = async (id) => {
  const { data } = await axiosInstance.get(appUrls.getPatientInfo(id));
  return data;
};

const fetchPatientShareInfo = async (id) => {
  return await axiosInstance.get(appUrls.getSharedUserInfo(id, true));
};

export { fetchPatientInfo, fetchPatientShareInfo };
